import { POST_SALES_SUPPLY } from "./type";

const initalState = {
  postSupplyData: [],
};

const supplyPostLeadReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_SUPPLY:
      return {
        ...state,
        postSupplyData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default supplyPostLeadReducer;
